import { createContext } from "react";
import { AuthUser } from "@mysnowscape/snow-lib";

export interface AuthState {
  authUser: AuthUser | null;
  authLoading: boolean;
  authReady: boolean;
  tokenAvailable: boolean;
}

export function makeAuthState(
  authUser: AuthUser | null,
  authLoading: boolean,
): AuthState {
  return {
    authUser,
    authLoading,
    authReady: !authLoading,
    tokenAvailable: authUser !== null,
  };
}

export const defaultAuthState = makeAuthState(null, true);

export const AuthContext = createContext<AuthState>(defaultAuthState);

export default AuthContext;
